module.exports = __webpack_public_path__ + "img/banner_2001.659fbb5a.png";